import { action } from 'satcheljs';
export const initializeUpNextV2 = action('INITIALIZE_UP_NEXT_V2');
